import React, { useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { NavLink } from "react-router-dom";
import DropzoneThumbnail from "../dropzone/DropzoneThumbnail";
import { toast } from "react-toastify";
import FamilyButtonAddModal from "./FamilyButtonAddModal";

const FamilyButtons = (props) => {
  const { answers } = props;
  const [activeIndex, setActiveIndex] = useState(null);

  const uploadModalRef = useRef();

  const { isDragActive, isDragAccept, isDragReject } = useDropzone();

  let dropzoneClass = "dropzone";
  if (isDragActive) dropzoneClass += " dropzone-active";
  if (isDragAccept) dropzoneClass += " dropzone-accept";
  if (isDragReject) dropzoneClass += " dropzone-reject";

  const handleIconClick = (index) => {
    if (index === activeIndex) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const deleteAnswer = async (id) => {
    try {
      if (window.confirm("Are you sure you want to delete answer ??")) {
        const response = null;
        if (response) {
          toast.success("Deleted");
          window.location.reload();
        }
      }
    } catch (error) {
      toast.error(error);
    }
  };

  return (
    <>
      <div className="data-table activityTable mt-5">
        <div className="tableStyle">
          <table>
            <thead>
              <tr>
                <th className="users-th">No</th>
                <th className="users-th">Thumbnail</th>
                <th className="users-th">Name of Family Member</th>
                <th className="users-th">Action</th>
              </tr>
            </thead>
            <tbody>
              {answers.map((answer, index) => (
                <tr key={index}>
                  <td className="users-td">{answer.familyMemberNumber}</td>
                  <td className="users-td">
                    <img
                      alt=""
                      style={{ height: "50px", borderRadius: "8px" }}
                    />
                  </td>
                  <td className="users-td">{answer.nameOfFamilyMember}</td>
                  <td className="users-td" style={{ width: "122px" }}>
                    <ion-icon
                      name="ellipsis-vertical-outline"
                      id="userAction"
                      onClick={() => handleIconClick(index)}
                      style={{ cursor: "pointer" }}
                    ></ion-icon>
                    {activeIndex === index && (
                      <div className="showOption-story">
                        {/* <NavLink
                          to={`/view-answer/${answer._id}`}
                          className="removeTextDecoration"
                        >
                          <p className="pt-3 d-flex align-items-center gap-2">
                            <ion-icon name="eye-outline"></ion-icon> View
                          </p>
                        </NavLink> */}

                        <p
                          className="d-flex align-items-center gap-2 mt-2"
                          data-bs-target="#editModal"
                          data-bs-toggle="modal"
                        >
                          <ion-icon name="create-outline"></ion-icon> Edit
                        </p>

                        <p
                          className="d-flex align-items-center gap-2"
                          style={{ color: "red" }}
                          onClick={() => deleteAnswer(answer._id)}
                        >
                          <ion-icon name="trash-outline"></ion-icon> Delete
                        </p>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Edit Modal */}
          <div
            className="modal fade"
            id="editModal"
            aria-hidden="true"
            aria-labelledby="exampleModalToggleLabel"
            tabindex="-1"
          >
            <FamilyButtonAddModal type="edit" answer={answers[activeIndex]} />
          </div>
        </div>
      </div>
    </>
  );
};

export default FamilyButtons;
